import { useEffect, useState } from "react"
import {
  usePathData,
  usePropsObject,
  useAdminBar
} from "@/lib/contexts/appContext"
import Main from "@/components/wrappers/main"
import Breadcrumbs from "@/components/base/breadcrumbs/breadcrumbs"
import Blocks from "@/components/Blocks"
import Byline from "@/common/article/byline"
import Card from "@/common/cards/article/article"
import CTA from "@/common/article/cta"
import Terms from "@/common/article/terms"
import Like from "@/common/social/like"
import Share from "@/common/social/share"
import styles from "./article.module.css"
import classNames from "classnames/bind"
import { pushDataLayer } from "@/lib/helpers/tagManager"

export default function Article() {
  const object = usePropsObject()
  const pathData = usePathData()
  const adminBar = useAdminBar()
  const cx = classNames.bind(styles)
  const [classes, setClasses] = useState({
    main: true
  })

  useEffect(() => {
    setClasses({
      ...classes,
      "has-admin-bar": adminBar
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathData])

  const related = object.related.posts.map((post, key) => {
    return (
      <li key={key}>
        <Card post={post} classes="mb-0" />
      </li>
    )
  })

  useEffect(() => {
    pushDataLayer(object.tracking)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Main className={cx(classes)}>
      <Breadcrumbs crumbs={object?.breadcrumbs} gap="none" />
      <article className={styles.article}>
        <Blocks blocks={pathData.content} />
      </article>
      <CTA data={object.cta} />
      <Terms
        terms={object.terms}
        className="max-w-screen-sm px-4 mt-10 sm:px-10 md:max-w-1xl"
      />
      <div className="box-content items-center justify-between max-w-screen-sm px-4 mx-auto mt-6 mb-6 sm:flex sm:px-10 md:max-w-1xl post-social no-print">
        <Like id={object.id} />
        <div className="flex">
          <Share classes="mt-4 sm:mt-0 mr-2 w-icon h-icon" url={object.url} />
        </div>
      </div>
      {object.byline && <Byline byline={object.byline} />}
      {related.length > 0 && (
        <div className={classNames(styles["related-wrapper"], "no-print")}>
          <h2 className="mb-8 text-xl sm:text-2xl lg:text-3xl">
            {object.related.label}
          </h2>
          <ul className="list">{related}</ul>
        </div>
      )}
    </Main>
  )
}
